"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCode = sendCode;
var _sendCode = require("../../repositories/validation-codes/v1/send-code");
var _types = require("./types");
async function sendCode(dependencies, phone) {
  const {
    httpApi,
    logger
  } = dependencies;
  try {
    const sendCodeResponse = await (0, _sendCode.fetchSendCode)({
      httpApi,
      parameters: {
        phone,
        type: _sendCode.EType.AuthenticateCode
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    if (sendCodeResponse.statusCode !== 200) {
      return {
        status: _types.ESendCodeStatus.Failed,
        message: sendCodeResponse.response.message,
        errors: sendCodeResponse.response.errors
      };
    }
    return {
      status: _types.ESendCodeStatus.Succeed,
      senderType: sendCodeResponse.response.senderType || null,
      secondsToRetry: sendCodeResponse.response.secondsToRetry || 60,
      timeStamp: new Date().getTime()
    };
  } catch (ex) {
    logger.error(ex, {
      domain: 'auth-widget.api.sendCode'
    });
    return {
      status: _types.ESendCodeStatus.Failed,
      message: 'Произошла непредвиденная ошибка',
      errors: []
    };
  }
}